import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    borderBottom: '1px solid #dadada',
    marginBottom: '30px',
    '& .MuiTabScrollButton-root': {
      color: theme.palette.common.black,
      position: 'absolute',
      height: '48px',
      zIndex: '9',
      background: 'rgb(255 255 255 / 0.8)',
      opacity: '1',
      right: 'auto',
      left: '0',
      '&:last-of-type': {
        right: '0',
        left: 'auto',
      },
      '&.Mui-disabled': {
        opacity: 0,
      },
      '& .MuiSvgIcon-fontSizeSmall': {
        fontSize: '36px',
        opacity: '1',
      },
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
    },
  },
  indicator: {
    backgroundColor: theme.palette.primary.dark,
    height: '3px',
  },
  vertical: {
    borderBottom: 0,
    borderRight: '1px solid #dadada',
    marginTop: '20px',
    '& .MuiTab-wrapper': {
      alignItems: 'start',
    },
    '& .MuiTabs-indicator': {
      width: '3px',
    },
  },
  tabRoot: {
    [theme.breakpoints.down('md')]: {
      minWidth: theme.spacing(15),
    },
  },
}));

const SideMenu = (props) => {
  const {
    menu, sideMenui18n, hasCount, onTabClick, currentSelectedMenuIdentifier,
  } = props;
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const classes = useStyles();

  const [activeItem, setActiveItem] = useState(0);
  const handleChange = (event, newValue) => {
    setActiveItem(newValue);
  };
  React.useEffect(() => {
    const itemIndex = menu.findIndex((item) => item.name === currentSelectedMenuIdentifier);
    setActiveItem(itemIndex);
  });
  return (
    <>
      <Tabs
        value={activeItem}
        onChange={handleChange}
        orientation={smallScreen ? 'horizontal' : 'vertical'}
        variant="scrollable"
        scrollButtons="on"
        classes={{
          root: classes.tabsRoot,
          indicator: classes.indicator,
          vertical: classes.vertical,
        }}
      >
        {menu.map((state) => (
          <Tab
            label={`${sideMenui18n[state.name]} ${hasCount ? `(${state.count})` : ''}`}
            key={state.name}
            classes={{
              root: classes.tabRoot,
            }}
            onClick={() => onTabClick(state.name)}
          />
        ))}
      </Tabs>
    </>
  );
};
export default SideMenu;
